import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetCampaignSeedingStatusCountsRequestSchema = z
  .object({
    campaignId: z.union([z.number(), z.string()]),
  })
  .describe('GetCampaignSeedingStatusCountsRequestSchema');

export type GetCampaignSeedingStatusCountsRequest = z.infer<
  typeof GetCampaignSeedingStatusCountsRequestSchema
>;

const SeedingParticipationStatusCountsSchema = z
  .object({
    campaignType: z.enum(['PROPOSAL', 'RECRUITMENT']),
    pendingAcceptanceCount: z.number().nullable().optional(),
    rejectedCount: z.number().nullable().optional(),
    pendingShipmentCount: z.number(),
    shippedCount: z.number(),
  })
  .describe('SeedingParticipationStatusCountsSchema');

export type SeedingParticipationStatusCounts = z.infer<
  typeof SeedingParticipationStatusCountsSchema
>;

const GetCampaignSeedingStatusCountsResponseSchema = createApiResponseSchema(
  SeedingParticipationStatusCountsSchema,
);

export type GetCampaignSeedingStatusCountsResponse = z.infer<
  typeof GetCampaignSeedingStatusCountsResponseSchema
>;

export const getCampaignSeedingStatusCounts = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCampaignSeedingStatusCountsRequestSchema),
    async ({ campaignId }: GetCampaignSeedingStatusCountsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetCampaignSeedingStatusCountsResponse>(
          partnerApiPath.getCampaignSeedingStatusCounts(campaignId),
        ),
      ),
    validateApiResponse(GetCampaignSeedingStatusCountsResponseSchema),
  ),
);
